import _ from "lodash";
/**
 * This function creates locale keys from templates
 * Its a backward compatible function
 * When some undefined, empty string or null value is passed in keys array those values are discarded
 *
 * @param {Object} param0
 * @param {Array} param0.keys - list of key to join with _
 *
 * @returns {Boolean} - Returns locale key of template string
 */
export const extractLabelsForTranslation = ({ keys }) => {
  const keydata = [];
  _.map(keys, data => {
    /**
     * When empty value comes it will discard
     */
    if (data) {
      const splitdata = data.split("_");
      _.map(splitdata, label => {
        if (!parseInt(label)) keydata.push(label);
      });
    }
  });
  keys = keydata.filter(Boolean);
  return keys.join("_");
};
